module.exports = TipTap.Link;


//////////////////
// WEBPACK FOOTER
// external "TipTap.Link"
// module id = 480
// module chunks = 0 1